import { ControlledInputField, ControlledDropdown, ControlledDatePicker } from '../../form-fields';
import { useFormContext } from 'react-hook-form';
import getConstants from '../../../util/constants';
import { envIsTrue } from '../../.././util/helpers';
import type { AuIdentificationLicenseData } from '@payright/types-bnpl-checkout-api';

const {
  IDENTIFICATION_MAX_YEARS_EXPIRY_FROM_TODAY,
  REGION_STATES,
  LICENCE_VALIDATION_REGEX,
  LICENCE_CARD_NUMBER_VALIDATION_REGEX,
} = getConstants();

type AuLicenceDetailsProps = {
  existingCustomer: boolean;
  editing: boolean;
};

export const AuLicenceDetails = ({ existingCustomer, editing }: AuLicenceDetailsProps) => {
  const { errors } = useFormContext<{
    identificationDetails: AuIdentificationLicenseData;
  }>();

  return (
    <div className="identification-details-fields">
      <ControlledInputField
        className="md:col-span-3"
        name="identificationDetails.licenseNo"
        rules={{
          required: 'Licence Number is required',
          pattern: envIsTrue('REACT_APP_SKIP_CUSTOMER_LICENCE_VALIDATION')
            ? undefined
            : {
                value: LICENCE_VALIDATION_REGEX,
                message: 'Licence Number format invalid',
              },
        }}
        error={(errors.identificationDetails as any)?.licenseNo?.message}
        readOnly={existingCustomer && !editing}
        isPrivate
      >
        Licence No.
      </ControlledInputField>
      <ControlledInputField
        className="md:col-span-3"
        name="identificationDetails.licenseCardNo"
        rules={{
          required: 'Card Number is required',
          pattern: envIsTrue('REACT_APP_SKIP_CUSTOMER_LICENCE_VALIDATION')
            ? undefined
            : {
                value: LICENCE_CARD_NUMBER_VALIDATION_REGEX,
                message: 'Card Number can contain a maximum of 10 alphanumeric characters only',
              },
        }}
        error={(errors.identificationDetails as any)?.licenseCardNo?.message as string}
        readOnly={existingCustomer && !editing}
        isPrivate
      >
        Card No.
      </ControlledInputField>

      <ControlledDropdown
        name="identificationDetails.licenseIssuingState"
        options={REGION_STATES}
        rules={{ required: 'Issuing State/Territory is required' }}
        readOnly={existingCustomer && !editing}
        error={(errors.identificationDetails as any)?.licenseIssuingState?.message}
        isPrivate
      >
        Issuing State/Territory
      </ControlledDropdown>
      <ControlledDatePicker
        className="md:col-span-2"
        name="identificationDetails.licenseExpiry"
        readOnly={existingCustomer && !editing}
        rules={{
          required: 'Licence expiry is required',
          validate: (value: any) => {
            const expiry = new Date(value);
            const today = new Date();
            today.setDate(today.getDate() + 1);
            if (expiry.getTime() < today.getTime()) {
              return 'Enter a valid expiry';
            }
          },
        }}
        error={(errors.identificationDetails as any)?.licenseExpiry?.message}
        startYear={new Date().getFullYear()}
        endYear={new Date().getFullYear() + IDENTIFICATION_MAX_YEARS_EXPIRY_FROM_TODAY}
        isPrivate
      >
        Expiry
      </ControlledDatePicker>
    </div>
  );
};
